(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPingIpAddress(
    $rootScope, EventServiceEvents, $timeout, PrinterListPOSTPaging
    ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationSettings/pingIpAddress/pingIpAddress.template.html',
      link: function(scope, element) {

        var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;

        var pingState = {
          IDLE: 'IDLE',
          PINGING: 'PENDING',
          TIMED_OUT: 'TIMED_OUT',
          FAILED: 'FAILED',
          SUCCESS: 'Ok'
        };

        scope.ipAddress = '';
        scope.ipAddressInvalid = true;

        scope.printerPaginationObject = null;

        scope.pingReport = [];
        var pingTask = {
          ip: null,
          startTime: null,
          endTime: null,
          timeElapsed: null,
          state: null,
          taskId: null
        }
        scope.focus = false;

        $timeout(function () {
          scope.focus = true;
        }, 100);

        scope.openPrinterList = function () {
          var tempPageObject =  new PrinterListPOSTPaging();
          tempPageObject.pagingCriteria.networks = scope.context.workstation.info._embedded.networks ? listOfNetworkIds(scope.context.workstation.info._embedded.networks) : null;
          tempPageObject.pagingCriteria.types = ["NETWORK", "VIRTUAL"];
          $timeout(function () {
            scope.printerPaginationObject = tempPageObject;
          }, 100)
        };

        function listOfNetworkIds (networks) {
          var networkIds = [];
          angular.forEach(networks, function (network) {
            networkIds.push(network._links.self.href);
          })
          return networkIds;
        }

        scope.selectPrinter = function (printer) {
          if (printer) {
            scope.ipAddress = printer.info.ipAddress.split(' ')[0];
            scope.runIpValidation();
            $timeout(function () {
              if (!scope.ipAddressInvalid) {
                scope.pingPrinter();
              }
            }, 100)
          }

          scope.printerPaginationObject = null;
        }

        scope.runIpValidation = function () {
          scope.ipAddressInvalid = !scope.ipAddress;
          /*
          scope.ipAddressInvalid = true;
          var ip = angular.copy(scope.ipAddress);
          if (ip && ip_regex.test(ip)) {
            scope.ipAddressInvalid = false;
          } else {
            scope.ipAddressInvalid = true;
          }
          */
        }

        element.on("keydown keypress", function (event) {
          if(event.which === 13) {
            event.preventDefault();
            scope.$apply(function (){
              if (!scope.ipAddressInvalid && scope.context.workstation.info.active) {
                scope.pingPrinter();
              }
            });
          }
        });

        scope.pingPrinter = function () {
          var newPingTask = angular.copy(pingTask)
          scope.context.workstation.pingPrinter(scope.ipAddress).then(function(response) {
            newPingTask.ip = scope.ipAddress;
            newPingTask.startTime = new Date().getTime();
            newPingTask.state = pingState.PINGING,
            newPingTask.taskId = response.data._links.self.href;
            scope.pingReport.push(newPingTask);
          }).catch(function(error){});
        }

        var WORKSTATION_TASK_STATUS_CHANGED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_STATUS_CHANGED, function (name, data) {
          if (data.task.indexOf(scope.context.workstation.customProperties.id) > -1 ) {
            for (var i = 0; i < scope.pingReport.length; i++) {
              if (scope.pingReport[i].taskId === data.task) {
                scope.pingReport[i].endTime = new Date().getTime();
                scope.pingReport[i].timeElapsed = scope.pingReport[i].endTime - scope.pingReport[i].startTime;
                scope.pingReport[i].state = data.newStatus;
              }
            }
          }
        })

        var WORKSTATION_TASK_REMOVED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_REMOVED, function(name, data) {

          if (data.task.indexOf(scope.context.workstation.customProperties.id) > -1 ) {
            for (var i = 0; i < scope.pingReport.length; i++) {
              if (scope.pingReport[i].taskId === data.task) {
                scope.pingReport[i].endTime = new Date().getTime();
                scope.pingReport[i].timeElapsed = scope.pingReport[i].endTime - scope.pingReport[i].startTime;
                scope.pingReport[i].state = pingState.SUCCESS;
              }
            }
          }
        });

        scope.$on('$destroy', function() {
          element.off("keydown keypress");
          WORKSTATION_TASK_STATUS_CHANGED_listener();
          WORKSTATION_TASK_REMOVED_listener();
        });

      }
    };
  }

  pxPingIpAddress.$inject = ['$rootScope', 'EventServiceEvents', '$timeout', 'PrinterListPOSTPaging'];

  angular
    .module('printix-admin')
    .directive('pxPingIpAddress', pxPingIpAddress);

})();
